'use strict';
import { form } from './form.fn';
angular.module('kerp-forms.forms')
  .factory(
    'PL_FCA_FORM',
    [
      'FormUI',
      'plymouthCareAssessmentCalculator',
      'htmlService',
      'fieldDefinitionService',
      'PL_FCA_CONDITIONS',
      '$window',

      form
    ]);
